import { FaWhatsapp, FaSpotify, FaYoutube, FaMusic } from "react-icons/fa";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const phoneNumber = "6281513951020"; // format WA (hapus 0 depan)

// TEMPLATE PESAN
const message = encodeURIComponent("Halo Management Kalia Siska,\n\nSaya tertarik untuk bekerja sama / endorsement.\n\nNama:\nBrand/Instansi:\nJenis Kerja Sama:\nDetail:\n\nTerima kasih 🙏");

const waLink = `https://wa.me/${phoneNumber}?text=${message}`;

const Kontak = () => {
  return (
    <section className="text-white">
      {/* ================= HERO ================= */}
      <div
        className="relative min-h-[80vh] flex items-center justify-center text-center px-4"
        style={{
          backgroundImage: "url('/images/feel.jpg')", // GANTI SESUAI GAMBAR
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}>
        {/* OVERLAY */}
        <div className="absolute inset-0 bg-black/70 backdrop-blur-[2px]" />

        {/* CONTENT */}
        <motion.div initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0 }} className="relative z-10 max-w-2xl">
          <p className="uppercase tracking-[0.3em] text-pink-400 text-sm mb-4">KERJA SAMA & ENDORSEMENT</p>

          <h1 className="text-3xl md:text-5xl font-bold mb-6">Kolaborasi Bersama Kalia Siska</h1>

          <p className="text-gray-300 mb-8 leading-relaxed">
            Terbuka untuk berbagai bentuk kerja sama seperti endorsement, brand collaboration, event performance, dan project kreatif lainnya. Hubungi langsung melalui WhatsApp untuk diskusi lebih lanjut.
          </p>

          {/* BUTTON WA */}
          <Link to={waLink} target="_blank" className="inline-flex items-center gap-3 bg-green-500 hover:bg-green-600 px-8 py-4 rounded-full font-semibold text-lg transition shadow-lg hover:scale-105">
            <FaWhatsapp size={22} />
            Hubungi via WhatsApp
          </Link>
        </motion.div>
      </div>

      {/* ================= PLATFORM ================= */}
      <div className="bg-gradient-to-b from-[#0f0f0f] to-[#1c1c1c] py-16 px-4">
        <div className="max-w-5xl mx-auto text-center">
          <motion.h2 initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} className="text-2xl md:text-3xl font-bold mb-8">
            Dengarkan di
          </motion.h2>

          <div className="flex flex-wrap justify-center gap-6">
            {/* SPOTIFY */}
            <Link to="https://open.spotify.com/artist/70hsEvlt6YZPT97UIvzpEu" target="_blank" className="flex items-center gap-3 bg-green-500 px-6 py-3 rounded-full hover:scale-105 transition">
              <FaSpotify />
              Spotify
            </Link>

            {/* YOUTUBE */}
            <Link to="https://www.youtube.com/results?search_query=kalia+siska+official" target="_blank" className="flex items-center gap-3 bg-red-500 px-6 py-3 rounded-full hover:scale-105 transition">
              <FaYoutube />
              YouTube
            </Link>

            {/* YOUTUBE MUSIC */}
            <Link to="https://music.youtube.com/channel/UCjNkJ90x4zh2WhfOI7geS3g" target="_blank" className="flex items-center gap-3 bg-white text-black px-6 py-3 rounded-full hover:scale-105 transition">
              <FaMusic />
              YouTube Music
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Kontak;
